import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BrandNav from "@/components/brand/BrandNav";
import BrandFooter from "@/components/brand/BrandFooter";
import { RouteThemeSync } from "@/contexts/ThemeProvider";

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col font-body" data-testid="app-root">
      <RouteThemeSync />
      <BrandNav />
      <main className="flex-1" data-testid="main-region">
        <Outlet />
      </main>
      <BrandFooter />
    </div>
  );
};

export default Layout;
